import { Box, IconButton, Tooltip } from '@mui/material';
import { Visibility } from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

export default function RightSidebar({
  isRightPanelCollapsed,
  onTogglePanel,
  onPanelOpen
}) {
  const theme = useTheme();
  
  return (
    <Box sx={{
      width: theme.spacing(5), // 40px at standard density
      bgcolor: 'background.paper',
      borderLeft: '1px solid',
      borderColor: 'divider',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 0,
    }}>
      <Tooltip 
        title={!isRightPanelCollapsed ? 'Hide Review Panel' : 'Show Review Panel'} 
        placement="left"
      >
        <Box
          sx={{
            position: 'relative',
            width: '100%',
            display: 'flex',
            justifyContent: 'center',
          }}
        >
          {!isRightPanelCollapsed && (
            <Box
              sx={{
                position: 'absolute',
                right: 0,
                top: '50%',
                transform: 'translateY(-50%)',
                width: theme.spacing(0.375), // 3px at standard density
                height: theme.spacing(4), // 32px at standard density
                bgcolor: 'primary.main',
                borderRadius: `${theme.spacing(0.25)} 0 0 ${theme.spacing(0.25)}`,
              }}
            />
          )}
          <IconButton
            onClick={() => {
              onTogglePanel(!isRightPanelCollapsed);
              // If opening the panel, trigger the open callback
              if (isRightPanelCollapsed && onPanelOpen) {
                onPanelOpen();
              }
            }}
            sx={{
              width: theme.spacing(5),
              height: theme.spacing(5),
              color: !isRightPanelCollapsed ? 'primary.main' : 'text.secondary',
              bgcolor: !isRightPanelCollapsed ? 'action.selected' : 'transparent',
              '&:hover': {
                color: 'text.primary',
                bgcolor: 'action.hover',
              },
              borderRadius: 0,
              '& .MuiSvgIcon-root': {
                fontSize: theme.dimensions.icon.medium,
              },
            }}
          >
            <Visibility />
          </IconButton>
        </Box>
      </Tooltip>
    </Box>
  );
}